<template>
	<div class="betslip">
		<div v-if="bets.length > 0" class="betslip-content">
			<bet v-for="bet in bets" :bet="bet" :key="bet.parent_match_id"></bet>
		</div>
		<div v-else class="betslip-content--empty">
			You have no {{ env.shikishaProductName }} bets in your betslip.
			<br />Kindly add some bets <br />
			<br />
			<router-link
				:to="env.shikishaProductName.replace(/\s/gi, '-').toLowerCase()"
				class="button button__secondary"
				>Go to {{ env.shikishaProductName }}</router-link
			>
		</div>
		<load-betslip v-if="bets.length == 0" class="betslip__load-code" />
		<div class="betslip__details">
			<div class="betslip__details__container" v-if="bets.length > 0">
				<div class="betslip__details__left">
					<div
						class="betslip__details__row"
						v-show="$store.getters.balance > 0 && loggedIn"
					>
						<span class="betslip__details__row__label">Wallet Balance</span>
						<span class="betslip__details__row__value">{{
							$store.getters.balance | currency
						}}</span>
					</div>
					<div class="betslip__details__row">
						<span
							class="betslip__details__row__label"
							style="flex-direction: column; align-items: flex-start"
						>
							<span>Total Odds</span>
							<small slot="desc">Min {{ env.minTotalOdd }} </small>
						</span>
						<span class="betslip__details__row__value"
							>{{ totalOdds > 1000000 ? "&#8734;" : totalOdds }}
							<br />
						</span>
					</div>
					<div class="betslip__details__row">
						<span
							class="betslip__details__row__label"
							style="flex-direction: column; align-items: flex-start"
						>
							<span>Amount</span>

							<small slot="desc"
								>{{ env.minimumBetAmount | currency }} -
								{{ env.maximumBetAmount | currency }}
							</small>
						</span>
						<input
							class="betslip__details__row__value input"
							type="number"
							name="amount"
							v-model="amount"
							:disabled="placingBet"
							min="1"
							step="1"
						/>
					</div>

					<div class="betslip__details__row">
						<span class="betslip__details__row__label">
							<span style="margin-right: 5px">Final Payout</span>

							<svg
								width="18"
								height="18"
								viewBox="0 0 10 11"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								@click="infoOpen = !infoOpen"
							>
								<path
									d="M5 0.40625C5.85938 0.40625 6.67969 0.640625 7.42188 1.07031C8.16406 1.5 8.75 2.08594 9.17969 2.82812C9.60938 3.57031 9.84375 4.39062 9.84375 5.25C9.84375 6.12891 9.60938 6.92969 9.17969 7.67188C8.75 8.41406 8.16406 9.01953 7.42188 9.44922C6.67969 9.87891 5.85938 10.0938 5 10.0938C4.12109 10.0938 3.32031 9.87891 2.57812 9.44922C1.83594 9.01953 1.23047 8.41406 0.800781 7.67188C0.371094 6.92969 0.15625 6.12891 0.15625 5.25C0.15625 4.39062 0.371094 3.57031 0.800781 2.82812C1.23047 2.08594 1.83594 1.5 2.57812 1.07031C3.32031 0.640625 4.12109 0.40625 5 0.40625ZM5 2.55469C4.76562 2.55469 4.57031 2.65234 4.41406 2.80859C4.25781 2.96484 4.17969 3.16016 4.17969 3.375C4.17969 3.60938 4.25781 3.80469 4.41406 3.96094C4.57031 4.11719 4.76562 4.19531 5 4.19531C5.21484 4.19531 5.41016 4.11719 5.56641 3.96094C5.72266 3.80469 5.82031 3.60938 5.82031 3.375C5.82031 3.16016 5.72266 2.96484 5.56641 2.80859C5.41016 2.65234 5.21484 2.55469 5 2.55469ZM6.09375 7.51562V7.04688C6.09375 6.98828 6.05469 6.92969 6.01562 6.89062C5.97656 6.85156 5.91797 6.8125 5.85938 6.8125H5.625V4.85938C5.625 4.80078 5.58594 4.74219 5.54688 4.70312C5.50781 4.66406 5.44922 4.625 5.39062 4.625H4.14062C4.0625 4.625 4.00391 4.66406 3.96484 4.70312C3.92578 4.74219 3.90625 4.80078 3.90625 4.85938V5.32812C3.90625 5.40625 3.92578 5.46484 3.96484 5.50391C4.00391 5.54297 4.0625 5.5625 4.14062 5.5625H4.375V6.8125H4.14062C4.0625 6.8125 4.00391 6.85156 3.96484 6.89062C3.92578 6.92969 3.90625 6.98828 3.90625 7.04688V7.51562C3.90625 7.59375 3.92578 7.65234 3.96484 7.69141C4.00391 7.73047 4.0625 7.75 4.14062 7.75H5.85938C5.91797 7.75 5.97656 7.73047 6.01562 7.69141C6.05469 7.65234 6.09375 7.59375 6.09375 7.51562Z"
									fill="#60981A"
								/>
							</svg>

							<div class="info-popup" v-show="infoOpen && bets.length > 0">
								<div class="info-popup__row" v-show="env.exciseTax > 0">
									<span class="info-popup__row__label">Excise Tax</span>
									<span class="info-popup__row__value">{{
										(exciseTax || 0) | currency
									}}</span>
								</div>
								<div class="info-popup__row" v-show="env.exciseTax > 0">
									<span class="info-popup__row__label">Stake</span>
									<span class="info-popup__row__value">{{
										(betAmount - exciseTax || 0) | currency
									}}</span>
								</div>
								<div class="info-popup__row">
									<span class="info-popup__row__label">Win</span>
									<span class="info-popup__row__value">{{
										(possibleWinnings || 0) | currency
									}}</span>
								</div>
								<div class="info-popup__row" v-show="env.whtTax > 0">
									<span class="info-popup__row__label">Withholding Tax</span>
									<span class="info-popup__row__value">{{
										(tax || 0) | currency
									}}</span>
								</div>
							</div>
						</span>
						<span class="betslip__details__row__value">
							{{ (possiblePayout || 0) | currency }}</span
						>
					</div>
				</div>
			</div>
			<div class="betslip__details__buttons" v-if="bets.length > 0">
				<button
					:amount="amount"
					:possibleWin="possibleWinnings"
					:totalOdds="totalOdds"
					:bonus="bonus"
					:points="points"
					:numberOfBets="numberOfBets"
					type="normal"
					class="betslip__details__button button button__primary full"
					@click="placeBet"
					:disabled="
						placingBet ||
						amount < 1 ||
						isNaN(amount) ||
						totalOdds < env.minTotalOdd
					"
				>
					<loader v-if="placingBet" />
					<span v-else>{{
						totalOdds < env.minTotalOdd
							? `Min total odds of ${env.minTotalOdd} required to place a bet`
							: "Place Bet"
					}}</span>
				</button>
				<share-button
					:bets="jengabetBetSlip"
					:profile-id="$store.getters.auth['user']['id']"
					:token="$store.getters.auth['token']"
					:bet-id="null"
					:product-type="'SHIKISHA'"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import Bet from "./ShikishaBetBet.vue";
import ShareButton from "../Share/ShareButton.vue";
import LoadBetslip from "../Share/LoadBetslip.vue";
export default {
	name: "shikisha-betslip",
	components: {
		Bet,
		ShareButton,
		LoadBetslip,
	},
	props: ["keep"],
	data() {
		return {
			amount: 100,
			changedMatches: [],
			placingBet: false,
			infoOpen: false,
		};
	},
	watch: {
		amount(n, o) {
			n > 300000 ? (this.amount = o) : false;
			n < 0 ? (this.amount = 100) : false;
		},
		numberOfBets(n, o) {
			let vm = this;
			if (n == 1 && o == 0) {
				vm.$nextTick(() => {
					vm.adjustBetslipHeight();
				});
			}
		},
	},
	mounted() {
		let vm = this;
		if (vm.$store.getters.layout == "Desktop" && bets.length > 0)
			vm.adjustBetslipHeight();
	},
	computed: {
		possiblePayout() {
			return Math.round((this.possibleWinnings - this.tax) * 100) / 100;
		},
		jengabetBetSlip() {
			return this.$store.state.jengabetBetSlip;
		},
		bets() {
			let betslip = this.$store.state.jengabetBetSlip;
			var grouped_bets = betslip.reduce((obj, bet) => {
				obj[bet.parent_match_id] = obj[bet.parent_match_id] || [];
				obj[bet.parent_match_id].push(bet);
				return obj;
			}, {});
			var groups = Object.keys(grouped_bets).map(function (key) {
				return { parent_match_id: key, bet: grouped_bets[key] };
			});
			return groups;
		},
		matches() {
			return this.$store.state.matches;
		},

		totalOdds() {
			let oddValues = this.jengabetBetSlip.map((bet) => {
				return Number(bet.odd.odd_value);
			});

			return Math.trunc(oddValues.reduce((a, b) => a * b, 1) * 100) / 100;
		},
		betAmount() {
			return this.amount;
		},
		possibleWinnings() {
			if (isNaN(this.betAmount)) return 0;
			let possibleWin =
				Math.trunc(this.totalOdds * (this.betAmount - this.exciseTax) * 100) /
				100;
			return possibleWin > this.env.maximumPossibleWin
				? this.env.maximumPossibleWin
				: possibleWin;
		},
		exciseTax() {
			return (
				Math.round(
					(this.betAmount - this.betAmount / (1 + this.env.exciseTax)) * 100
				) / 100
			);
		},
		tax() {
			let maxTax = this.possibleWinnings * this.env.whtTax;
			let tax =
				Math.round(
					(this.possibleWinnings - (this.betAmount - this.exciseTax)) *
						this.env.whtTax *
						100
				) / 100;
			if (tax < 0) return 0;
			return tax > maxTax ? maxTax : tax;
		},
		finalPayout() {
			return Math.trunc((this.possibleWinnings - this.tax) * 100) / 100;
		},
		bonus() {
			// Give bonus to only those bets with odd values >= 1.6
			let validOdds = this.jengabetBetSlip
				.filter((bet) => Number(bet.odd.odd_value) >= 1.6)
				.map((bet) => bet.odd.odd_value);

			// Multiply all valid odds
			let bonusOdds = validOdds.reduce((a, b) => a * b, 1);

			// Minimum bonus ratio of 5 for 5 bets
			let minimumBonusRatio = 5;

			/* Calculated bonus ratio based on
            ratio(length - ratio) || 5
          i.e. 5 bets = bonus ratio of 5, 6 bets bonus ratio of 10
      */
			let bonusRatio =
				validOdds.length == 5
					? minimumBonusRatio
					: (validOdds.length - minimumBonusRatio) * 5;

			// Give bonus for 5+ bets with odd values that are 1.5+
			if (validOdds.length >= 5) return bonusOdds * 50 * (bonusRatio / 100);
			return 0;
		},
		points() {
			if (this.totalOdds <= 3) return 0;
			let points = this.possibleWinnings / 100;
			return Math.round(points > 50 ? 5000 : points * 100) / 100;
		},
		loggedIn() {
			return JSON.parse(window.localStorage.getItem("authenticated"));
		},
		numberOfBets() {
			return this.bets.length;
		},
	},
	methods: {
		adjustBetslipHeight() {
			var desktopOffset = parseInt(
				getComputedStyle(document.body)
					.getPropertyValue("--desktop-header-offset")
					.trim()
					.replace("px", "")
			);
			var betslipDetailsHeight = document
				.querySelector(".betslip__details")
				.getBoundingClientRect().height;
			var padding = 20;
			var bottomOffset = 300;
			var betslipContentHeight = `${
				window.innerHeight -
				(desktopOffset + betslipDetailsHeight + padding + bottomOffset)
			}px`;
			document.querySelector(".betslip-content").style.maxHeight =
				betslipContentHeight;
			document.querySelector(".betslip-content").style.height = "auto";
			document.querySelector(".betslip-content").classList.add("adjusted");
		},
		clearBetslip() {
			window.confirm("Are you sure you want to clear the betslip?") == true
				? this.$store.commit("clearJengabetBetslip")
				: "";
		},
		refreshBalance() {
			this.$axios
				.post(`${BASE_URL}balance`, {
					token: window.localStorage.getItem("token")
						? JSON.parse(window.localStorage.getItem("token"))
						: "",
				})
				.then((response) => {
					this.$store.commit("setBalance", response.data.user.balance);
				})
				.catch((error) => {
					console.log(error);
				});
		},
		placeBet() {
			let vm = this;
			if (vm.placingBet) return;
			if (this.amount > 20000) {
				vm.$notifications.add({
					type: "warning",
					title: "Bet amount limit",
					message: `Maximum bet amount is ${vm.$options.filters.currency(
						20000
					)}`,
					duration: 5000,
				});
				return;
			}

			vm.placingBet = true;

			// Check whether the user is authenticated
			if (!JSON.parse(window.localStorage.getItem("authenticated"))) {
				vm.placingBet = false;

				vm.$notifications.add({
					type: "warning",
					title: "Authentication required",
					message: "Please login first",
					duration: 3000,
				});
				this.$router.push("/login");
				return;
			}

			// Check whether amount > 50
			if (vm.amount < 1) {
				vm.placingBet = false;

				vm.$notifications.add({
					type: "warning",
					title: "Bet amount limit",
					message: `Minimum bet amount is ${vm.$options.filters.currency(1)}`,
					duration: 5000,
				});
				return;
			}

			// Map betslip to endpoint requirements
			let betslip = vm.jengabetBetSlip.map((bet) => {
				return {
					sub_type_id: bet.type,
					bet_pick: bet.odd.odd_key,
					odd_value: bet.odd.odd_value,
					special_bet_value: bet.odd.special_bet_value
						? bet.odd.special_bet_value
						: "",
					parent_match_id: bet.odd.parent_match_id,
					bet_type: 5,
					is_shared: bet.is_shared,
					share_code: bet.share_code,
				};
			});

			// check betslip length
			if (betslip.length < 2) {
				this.placeBetButton = "Place Bet";
				e.target.classList.remove("disabled");
				vm.placingBet = false;

				vm.$notifications.add({
					message: "Minimum picks accepted is 2",
					title: "Bet limit warning",
					type: "warning",
					duration: 5000,
				});
				return;
			}

			// Build payload
			let payload = {
				profile_id: window.localStorage.getItem("user")
					? JSON.parse(window.localStorage.getItem("user")).id
					: "",
				stake: this.amount.toString(),
				total_odd: this.totalOdds.toString(),
				src: "MOBILE_WEB",
				betslip: betslip,
				token: window.localStorage.getItem("token")
					? JSON.parse(window.localStorage.getItem("token"))
					: "",
				user_agent: localStorage.user_agent ? localStorage.user_agent : null,
				affiliate: localStorage.affiliate ? localStorage.affiliate : null,
			};

			vm.$tracking.bet.shikisha.start({
				no_of_bets: betslip.length,
				total_odds: vm.totalOdds,
				bet_amount: vm.amount,
				bet_type: "shikisha",
			});

			if (vm.$store.getters["affiliates/affiliateTag"] && !vm.env.disabledFeatures.includes("affiliates")) {
				payload.affiliate_id = vm.$store.getters["affiliates/affiliateID"];
				payload.affiliate_tag = vm.$store.getters["affiliates/affiliateTag"];
			}

			// Server request
			vm.$axios
				.post(`${BASE_URL}betbuilder/placebet`, payload)
				.then((response) => {
					vm.placingBet = false;

					vm.$tracking.bet.shikisha.success({
						no_of_bets: betslip.length,
						total_odds: vm.totalOdds,
						bet_amount: vm.amount,
						bet_type: "shikisha",
						bet_id: response.data.bet_id,
						message: response.data.message,
						first_bet: response.data.first_bet == 1,
					});

					vm.$notifications.add({
						type: "success",
						title: "Bet placement successful",
						message: response.data.message,
						duration: 10000,
					});
					vm.$store.commit("setBalance", response.data.user.balance);
					vm.$store.commit("SET_MYBETS_LAST_FETCH_TIME", null);

					if (!vm.keep) {
						vm.$store.commit("clearJengabetBetslip");
						vm.$router.go("-1");
					}
				})
				.catch((error) => {
					vm.placingBet = false;
					vm.$tracking.bet.shikisha.failed({
						no_of_bets: betslip.length,
						total_odds: vm.totalOdds,
						bet_amount: vm.amount,
						bet_type: "shikisha",
						message: error.response
							? error.response.data.message
							: error.message,
					});
					if (error.response && error.response.status == 401) {
						vm.$auth.logout();
						vm.$notifications.add({
							type: "error",
							title: "Session expired",
							message: "Your session has expired. Please login again",
							duration: 10000,
						});
						vm.$router.replace("/login");
						return;
					}
					vm.$notifications.add({
						type: "error",
						title: "Bet placement failed",
						message: error.response
							? error.response.data.message
							: "An error occurred. Please try again and contact us if this persists.",
						duration: 10000,
					});
				});
		},
	},
};
</script>
